import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';
import { adaptor, transformOptions, meta } from './adaptor';
import './interaction';

var Scatter =
/** @class */
function (_super) {
  __extends(Scatter, _super);

  function Scatter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'point';
    return _this;
  }
  /**
   * @override
   * @param data
   */


  Scatter.prototype.changeData = function (data) {
    this.updateOption(transformOptions(deepAssign({}, this.options, {
      data: data
    })));

    var _a = this,
        options = _a.options,
        chart = _a.chart;

    meta({
      chart: chart,
      options: options
    });
    this.chart.changeData(data);
  };
  /**
   * 获取散点图的适配器
   */


  Scatter.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  Scatter.prototype.getDefaultOptions = function () {
    return deepAssign({}, _super.prototype.getDefaultOptions.call(this), {
      size: 4,
      tooltip: {
        showTitle: false,
        showMarkers: false,
        showCrosshairs: true,
        crosshairs: {
          type: 'xy'
        }
      }
    });
  };

  return Scatter;
}(Plot);

export { Scatter };